export type DunningStatus = 'restricted' | 'locked'

// Shared copy for the payment-failure dunning gate (see #21609) — used by both DropdownNewButton's
// tooltip and Header's banner so the two surfaces can't drift out of sync. The server enforces the
// actual gate (assertQuoteActionAllowed.ts) regardless of what's shown here.
export function getDunningStatusMessage(status: DunningStatus): string {
  return status === 'locked'
    ? 'This account is locked due to a failed payment.'
    : 'This account is restricted due to a failed payment — new quotes and invoices can’t be created or sent.'
}
